// Navigation items configuration
const navItems = [
  {
    path: "/",
    label: "Home",
    children: [
      {
        path: "/",
        label: "Home One",
      },
      {
        path: "/home-2",
        label: "Home Two",
      },
    ],
  },
  { path: "/about", label: "About Us" },
  { path: "/services", label: "Services" },
  {
    path: "#",
    label: "Portfolio",
    children: [
      { path: "/portfolio", label: "Portfolio" },
      { path: "/portfolio/3", label: "Portfolio Details" },
    ],
  },
  {
    path: "/pages",
    label: "Pages",
    children: [
      { path: "/blog", label: "Blog" },
      { path: "/blog/2", label: "Blog Details" },
      { path: "/price", label: "Pricing Plan" },
      { path: "/testimonials", label: "Client Testimonials" },
      { path: "/team", label: "Team" },
      { path: "/faq", label: "FAQ" },
      { path: "/404", label: "404" },
      { path: "/headers", label: "Headers" },
      { path: "/footers", label: "Footers" },
    ],
  },

  { path: "/contact", label: "Contact Us" },
];

export { navItems };
